import React from 'react'
import './Image.css'
import classNames from 'classnames'

const Image = ({ src = '', ...props }) => {
  let classes = classNames({
    'Image': true
  })

  return (
    <div className={classes} style={{backgroundImage: `url(${src})`}} role='presentation' {...props} />
  )
}

export default Image



// WEBPACK FOOTER //
// ./src/Components/Image/Image.js